import client from '../axios'
import getCSRFTokenApi from './getCsrfTokenApi';

const forgotPasswordApi = async (data) => {
    await getCSRFTokenApi();
    return client.post('/api/forgot-password', data);
};

export default forgotPasswordApi;